$(document).ready(function(){

  let swiper;

   AOS.init();

  // description tab js

  $('.product_description_tab .tab_head').click(function () {
    console.log("clicked");

    if($(this).parent().hasClass("active"))
    {
      $('.product__description.rte').slideUp();
      $(this).parent().removeClass('active');
    }
    else{
      $(this).parent().addClass('active');
      $('.product__description.rte').slideDown();
    }
  });

    $('.product_specifications_tab .tab_head').click(function () {
    console.log("clicked");

    if($(this).parent().hasClass("active"))
    {
      $('.product__specifications').slideUp();
      $(this).parent().removeClass('active');
    }
    else{
      $(this).parent().addClass('active');
      $('.product__specifications').slideDown();
    }
  });

  // description tab js

  // search js

  $(document).on("click",".itg_search_icon",function() {
    $('.itg_header .itg_search search-form, .search-results-overlay').addClass('active');
    $('.header__top .logo').css("visibility","hidden");

  });
  $(document).on("click",".search-results-overlay",function() {
    $('.itg_header .itg_search search-form, .search-results-overlay').removeClass('active');
    $('.header__top .logo').css("visibility","visible");
  });



  // search js

  // collection tab js

  $('.collection_tab_head .collection_title a').click(function (e) {

    const isMobile = $(window).width() < 768;
    const href = $(this).attr('href');

    if (isMobile && href && href !== '#') {
        return;
    }

    e.preventDefault();

    $('.collection_tab_head .collection_title').removeClass("active");
    $(this).parent().addClass("active");

    var HeadtabToShow = $(this).parent().attr("data-tab");

    $('.all_collection_products .single_collection_products').each(function (index, value) {
        var prodCollectionTab = $(value).attr("data-tab");
        if (HeadtabToShow == prodCollectionTab) {
            $('.all_collection_products .single_collection_products').removeClass("active");
            $(value).addClass("active");
        }
    });

    initializeSwiper();

});


  // collection tab js

  // console.log("hell");

  function initializeSlider() {
        let windowWidth = $(window).width();

       if(windowWidth <= 992){
         if (!$('.itg_text_columns .grid.slick-initialized').length) {
                $('.itg_text_columns .grid').slick({
                  slidesToShow: 2,
                  responsive: [
                     {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            dots: false,
                            arrows: true
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '0',
                            dots: true,
                            arrows: false
                        }
                    }
                  ]
                });
            }
       }

        // Initialize other sliders if window width <= 768
        if (windowWidth <= 768) {
            const slickSettings = {
                infinite: true,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '0',
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            };

            // Testimonials Slider
            if (!$('.itg_testimonials_main.slick-initialized').length) {
                $('.itg_testimonials_main').slick($.extend({}, slickSettings, {
                    slidesToShow: 2,
                    infinite: true // Unique settings for testimonials
                }));
            }

            // Blogs Slider
            if (!$('.all_blogs_container.slick-initialized').length) {
                $('.all_blogs_container').slick($.extend({}, slickSettings, {
                    slidesToShow: 2,
                    infinite: false // Unique settings for blogs
                }));
            }
        }
    }

    // Initialize the sliders on page load
    initializeSlider();
    initializeSwiper();

    // Re-initialize sliders on window resize, but only if necessary
    $(window).on('resize', function() {
        initializeSlider();
        initializeSwiper();
    });



      function initializeSwiper() {
        let windowWidth = $(window).width();

        // Check if screen width is less than or equal to 991px
        if (windowWidth <= 991) {
            // Initialize Swiper if it hasn't been initialized yet
            if (!swiper) {
                swiper = new Swiper('.swiper', {
                    direction: 'horizontal',
                    loop: false,
                    slidesPerView: 3,
                    spaceBetween: 30,
                    // Navigation arrows
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        767: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        }
                    }
                });
            }
        } else {
            // Destroy Swiper instance if screen width is greater than 991px
            if (swiper) {
                swiper.destroy(true, true);
                swiper = undefined; // Set the swiper variable to undefined to reset it
            }
        }
    }


  // recently viewed products js

  // Function to set a cookie
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to get a cookie by name

    // Function to set a cookie

      function setCookie(name, value, days) {
          var expires = "";
          if (days) {
              var date = new Date();
              date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
              expires = "; expires=" + date.toUTCString();
          }
          document.cookie = name + "=" + (value || "") + expires + "; path=/";
      }

      // Function to get a cookie by name
      function getCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) === ' ') c = c.substring(1, c.length);
              if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
          }
          return null;
      }

      // Function to get recently viewed products from the cookie
      function getRecentlyViewedProducts() {
          var recentlyViewed = getCookie('recentlyViewed');
          if (recentlyViewed) {
              $('.no_recently_products').hide();
          }
          return recentlyViewed ? JSON.parse(recentlyViewed) : [];
      }

      // Function to add a product handle to the recently viewed products
      function addRecentlyViewedProduct(handle) {
          var recentlyViewed = getRecentlyViewedProducts();

          // Check if handle already exists, if not, add it
          if (!recentlyViewed.includes(handle)) {
              recentlyViewed.unshift(handle); // Add to the beginning of the array
              if (recentlyViewed.length > 4) recentlyViewed.pop(); // Keep only the last 4 products
              setCookie('recentlyViewed', JSON.stringify(recentlyViewed), 7); // Set cookie for 7 days
          }
      }

      // Function to fetch product details using Shopify AJAX API
      function fetchProductDetails(handle, callback) {
          fetch('/products/' + handle + '.js')
              .then(response => response.json())
              .then(product => callback(product))
              .catch(err => console.error('Error fetching product:', err));
      }

      // Function to render the recently viewed products
      function renderRecentlyViewedProducts() {
          var recentlyViewed = getRecentlyViewedProducts();
          var recentlyViewedList = document.getElementById('recently-viewed-list');

          recentlyViewed.forEach(function(handle) {
              fetchProductDetails(handle, function(product) {
                  var listItem = document.createElement('li');
                  listItem.innerHTML = `
                      <a href="${product.url}">
                          <div class="prod_img">
                              <img src="${product.images[0]}" alt="${product.title}" width="50">
                          </div>
                          <div class="prod_content">
                              <h4>${product.title}</h4>
                              <h4 class="prod_price"> $${product.price / 100} <span class="compare_at_price"> ${product.compare_at_price == null ? "" : "$" + ((product.compare_at_price / 100).toFixed(2)) }</span></h4>
                          </div>
                      </a>
                  `;
                  recentlyViewedList.appendChild(listItem);
              });
          });
      }

      // Adding the current product handle to the recently viewed list if on a product page
      if (window.location.pathname.includes('/products/')) {
          const currentProductHandle = window.location.pathname.split('/products/')[1];
          addRecentlyViewedProduct(currentProductHandle);
      }

      // Only render if we have a recently viewed list element on the page
      if (document.getElementById('recently-viewed-list')) {
          renderRecentlyViewedProducts();
      }



    $('#search_faq').on('keyup', function() {
        var searchText = $(this).val().toLowerCase();
        var sectionHasMatches = false; // Track if any matches are found in the entire section

        $('.itg_content_toggles .faq-items').each(function(index, element) {

            var itemHasMatch = false; // Track if there’s a match within this specific item

            $(element).find(".toggle--faq").each(function(index, elem) {
                var faqText = $(this).text().toLowerCase();
                var isMatch = faqText.includes(searchText);

                $(this).toggle(isMatch); // Show or hide based on match

                if (isMatch) {
                    itemHasMatch = true; // Mark that this specific item has a match
                    sectionHasMatches = true; // Mark that the section has at least one match
                }
            });

            $(element).parents(".itg_content_toggles").toggle(itemHasMatch); // Show or hide the entire `.faq-items` if it has no match

        });

       $('.no_results_found').toggle(!sectionHasMatches);


    });

});


/* product-description */
document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('readMoreToggle');
    const description = document.getElementById('productDescription');

    if (toggle && description) {
      toggle.addEventListener('click', () => {
        const collapsed = description.classList.toggle('product__description--collapsed');
        toggle.textContent = collapsed ? 'Read more' : 'Read less';
      });
    }
  });


 /* sidebar-menu-mobile */
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('add-link')) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const anchor = e.target.closest('a');
      const href = anchor?.getAttribute('href');

      if (anchor && href && href !== '#') {
        window.location.href = href;
      }
    }
  }, true);

/* announcement-bar popup */
  document.addEventListener("DOMContentLoaded", function () {
    const announcements = document.querySelectorAll(".announcement");

    announcements.forEach(function (item) {
      item.addEventListener("click", function (e) {
        e.preventDefault();

        const targetId = item.getAttribute("data-block-id");
        const popup = document.getElementById(targetId);
        const overlay = document.getElementById("overlay-" + targetId.replace("popup-", ""));

        popup.style.display = "block";
        overlay.style.display = "block";

        popup.querySelector(".close-popup").addEventListener("click", function () {
          popup.style.display = "none";
          overlay.style.display = "none";
        });

        overlay.addEventListener("click", function () {
          popup.style.display = "none";
          overlay.style.display = "none";
        });
      });
    });

    /******  add read-more read-less condition  ******/
    /*
    const contentDiv = document.getElementById("popupText");
    const toggleLink = document.getElementById("toggleLink");
    const fullText = contentDiv.textContent.trim();
    const maxLength = 100;

    if (fullText.length <= maxLength) {
      toggleLink.style.display = "none";
      return;
    }

    const shortText = fullText.substring(0, maxLength) + "...";
    let isExpanded = false;

    contentDiv.textContent = shortText;

    toggleLink.addEventListener("click", function (e) {
      e.preventDefault();
      isExpanded = !isExpanded;
      contentDiv.textContent = isExpanded ? fullText : shortText;
      toggleLink.textContent = isExpanded ? "Read less" : "Read more";
    });*/

  });